import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faBars,
  faTimes,
  faTriangleExclamation,
  faLaptop,
  faPenToSquare,
  faThumbTack,
  faFire,
  faSun,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faFacebook,
  faInstagram,
  faYoutube,
  faBars,
  faTimes,
  faTriangleExclamation,
  faLaptop,
  faPenToSquare,
  faThumbTack,
  faFire,
  faSun
);
